import { useEffect } from 'react';

const TealiumTracker = () => {
  useEffect(() => {
    if (window.utag && window.utag.view) {
      window.utag.view({
        page_name: "Главная страница",
        page_type: "Помогайки Армения",
        site_area: "public",
        user_status: "guest"
      });
    }
  }, []);

  return null; 
};

export default TealiumTracker;
